import {
  FETCH_LESSONS_REQUEST,
  FETCH_LESSONS_SUCCESS,
  FETCH_LESSONS_FAILURE,
  ADD_LESSON_REQUEST,
  ADD_LESSON_SUCCESS,
  ADD_LESSON_FAILURE,
  UPDATE_LESSON_REQUEST,
  UPDATE_LESSON_SUCCESS,
  UPDATE_LESSON_FAILURE,
  DELETE_LESSON_REQUEST,
  DELETE_LESSON_SUCCESS,
  DELETE_LESSON_FAILURE,
} from './actionTypes';

const initialState = {
  lessons: { data: [] },
  loading: false,
  error: null,
};

const lessonReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─────────────── FETCH ───────────────
    case FETCH_LESSONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_LESSONS_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: action.payload || { data: [] },
      };

    case FETCH_LESSONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ─────────────── ADD / UPDATE / DELETE REQUEST ───────────────
    case ADD_LESSON_REQUEST:
    case UPDATE_LESSON_REQUEST:
    case DELETE_LESSON_REQUEST:
      return {
        ...state,
        loading: true,
      };

    // ─────────────── ADD SUCCESS ───────────────
    case ADD_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: {
          ...state.lessons,
          data: [...(state.lessons?.data || []), action.payload?.data || action.payload],
        },
      };

    // ─────────────── UPDATE SUCCESS ───────────────
case UPDATE_LESSON_SUCCESS:
  return {
    ...state,
    loading: false,
    lessons: {
      ...state.lessons,
      data: (state.lessons?.data || []).map((item) => {
        if (item?._id === (action.payload?._id)) {
          return {
            ...item,                
            ...action.payload,      
            chapterId:
              typeof action.payload.chapterId === "string"
                ? item.chapterId     
                : action.payload.chapterId || item.chapterId,
          };
        }
        return item;
      }),
    },
  };






    // ─────────────── DELETE SUCCESS ───────────────
    case DELETE_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: {
          ...state.lessons,
          data: (state.lessons?.data || []).filter(
            (item) => item?._id !== (action.payload?.data?._id || action.payload?._id)
          ),
        },
      };

    // ─────────────── FAILURES ───────────────
    case ADD_LESSON_FAILURE:
    case UPDATE_LESSON_FAILURE:
    case DELETE_LESSON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default lessonReducer;
